import React from 'react';
import { Link } from '../link';

function LanguageSelector({ linkLangMap, langCode, className }) {
  return (
    <>
      {Object.keys(linkLangMap).length > 1 &&
        Object.keys(linkLangMap)
          .filter((k) => k !== langCode)
          .map((k) => (
            <Link
              className={className}
              to={linkLangMap[k]}
              localize={false}
              key={k}
            >
              <span>{k.slice(0, 2).toUpperCase()}</span>
            </Link>
          ))}
    </>
  );
}

export default LanguageSelector;
